type MortgageProductCode {
  productCode: String
  name: String
  id: String
  lender: String
}

input MortgageProductBySourcingIdInput {
  isBtl: Boolean!
  sourcingProductId: String
  loanAmount: String
  valuationAmount: String
  isCurrent: Boolean
}
